export default __webpack_public_path__ + "scene1_4_icon01bebd.png";